import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { map } from 'rxjs/operators';
import { Refund } from '../models/refund.model';


const BASE_URL = environment.base_url;

@Injectable({
    providedIn: 'root'
})
export class RefundService {

    constructor(
        private http: HttpClient
    ) { }

    create(scanId: string, filePath: string, comment) {

        const token = localStorage.getItem('token') || '';

        return this.http.post(`${BASE_URL}/refund`, {
            scanId,
            filePath,
            comment
        }, {
            headers: {
                'X-Amz-Security-Token': token
            }
        })
    }

    findAll(status: string) {
        const url = `${BASE_URL}/refund/${status}`;
        const token = localStorage.getItem('token') || '';

        const headers = {
            'X-Amz-Security-Token': token
        }

        return this.http.get(url, { headers }).pipe(
            map((resp: { refunds: Refund[] }) => resp.refunds)
        )
    }

    changeStatus(ID: string, status: string) {
        const url = `${BASE_URL}/refund`;
        const token = localStorage.getItem('token') || '';

        const headers = {
            'X-Amz-Security-Token': token
        }

        return this.http.put(url, {
            ID,
            status
        }, { headers }).pipe(
            map((resp: { refunds: Refund[] }) => resp.refunds)
        )
    }
}
